import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { BookingService } from './../../services/booking.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';


@Component({
  selector: 'check-controlled-item-import',
  templateUrl: './check-controlled-item.component.html',
  styleUrls: ['./check-controlled-item.component.scss']
})
export class CheckControlledItemComponent extends SessionBaseComponent implements OnInit {

  readonly permissionCode: PermissionConstants = PermissionConstants.CreateBooking;
  @Input() checkLicenseNoList: any;
  @Output() ItemLicenseImported: EventEmitter<any>;
  isShowControlledItemModal: boolean;
  showLicenseNoEmpty: boolean;

  constructor(
    injector: Injector,
    private bookingService: BookingService) {
    super(injector);
    this.ItemLicenseImported = new EventEmitter<any>();
    this.isShowControlledItemModal = false;
    this.checkLicenseNoList = null;
    this.showLicenseNoEmpty = false;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  confirmBtnClick(event: any): void {

    for (var checkLicenseNoBean in this.checkLicenseNoList) {
      if (this.checkLicenseNoList[checkLicenseNoBean].licenseNo == "") {
            this.showLicenseNoEmpty = true;
      }
    }

    if (!this.showLicenseNoEmpty) {
      this.bookingService.checkLicenseNo(this.checkLicenseNoList)
      .subscribe({
        next: result => {
          if (result == "Y") {
            this.ItemLicenseImported.emit({ originalEvent: event });
            return;
          } else {
            //管制品憑證編號不正確
            this.translateService.get('CreateBooking.Alert.CertificateNumIncorrect')
            .subscribe({
              next: result => {
                this.toastService.warn(result);
              }
            });

            return;
          }
        },
        error: (error: HttpErrorResponse) => {
          if (error.status === 400) {
            this.toastService.error(error.error);
          }
        }
      });
    } else {
      //管制品憑證編號不可為空
      this.translateService.get('CreateBooking.Alert.CertificateNumBlank')
            .subscribe({
              next: result => {
                this.toastService.warn(result);
              }
            });
    }

  }

  showMsgByLicenseNoEmpty(licenseNo: any): void {
    if (licenseNo == null || licenseNo == "") {
      this.showLicenseNoEmpty = true;
    } else {
      this.showLicenseNoEmpty = false;
    }
  }
}

